import { render, staticRenderFns } from "./OrganizationSessionDetail.vue?vue&type=template&id=f45ced58&scoped=true"
import script from "./OrganizationSessionDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationSessionDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSessionDetail.vue?vue&type=style&index=0&id=f45ced58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ced58",
  null
  
)

export default component.exports